import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH, HUD_HEIGHT, TILE } from "./constants";
import { BootScene } from "./scenes/BootScene";
import { LevelScene } from "./scenes/LevelScene";
import { MenuScene } from "./scenes/MenuScene";

export { GAME_HEIGHT, GAME_WIDTH, HUD_HEIGHT, TILE };

export const COLORS = {
  sky: 0x4ec5d4,
  skyNight: 0x11152e,
  underground: 0x0d1235,
  castle: 0x10080f,
  athletic: 0xf07b78,
  hud: 0xffffff,
  black: 0x090b18,
  white: 0xffffff,
  red: 0xf05252,
  cream: 0xfff3d0,
  gold: 0xffcc4d,
  cyan: 0x46e6d4,
  violet: 0x7557d3,
  ink: 0x11152e,
} as const;

export const FONT = '"Arial Black", "Avenir Next", system-ui, sans-serif';

export const EVENTS = {
  audioToggle: "audio-toggle",
} as const;

export function createGameConfig(): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO,
    parent: "game-container",
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: COLORS.sky,
    antialias: false,
    pixelArt: true,
    roundPixels: true,
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: 0 },
        debug: false,
        fps: 60,
        fixedStep: true,
      },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: GAME_WIDTH,
      height: GAME_HEIGHT,
    },
    render: {
      antialias: false,
      pixelArt: true,
      roundPixels: true,
      powerPreference: "high-performance",
    },
    input: {
      // Move + run + jump/fire + pause can all be held on touch at once.
      activePointers: 5,
    },
    scene: [BootScene, MenuScene, LevelScene],
  };
}
